export const logInfo = cityId => {
  return dispatch => {
    console.log(cityId, '====cityId');
  };
};



// WEBPACK FOOTER //
// ./src/actions/logActions.js